var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 0C23.6421 0 27 3.6066 27 8.05556V20.9444C27 25.3934 23.6421 29 19.5 29H7.5C3.35787 29 0 25.3934 0 20.9444L0 8.05556C0 3.6066 3.35787 0 7.5 0L19.5 0ZM19.5 3.22222L7.5 3.22222C5.01473 3.22222 3 5.38619 3 8.05556L3 20.9444C3 23.6139 5.01473 25.7778 7.5 25.7778H19.5C21.9853 25.7778 24 23.6139 24 20.9444V8.05556C24 5.38619 21.9853 3.22222 19.5 3.22222ZM13.5 8.05556C16.8137 8.05556 19.5 10.9408 19.5 14.5C19.5 18.0591 16.8137 20.9444 13.5 20.9444C10.1863 20.9444 7.5 18.0591 7.5 14.5C7.5 10.9408 10.1863 8.05556 13.5 8.05556ZM13.5 11.2778C11.8431 11.2778 10.5 12.7204 10.5 14.5C10.5 16.2796 11.8431 17.7222 13.5 17.7222C15.1569 17.7222 16.5 16.2796 16.5 14.5C16.5 12.7204 15.1569 11.2778 13.5 11.2778ZM20.25 5.63889C21.0784 5.63889 21.75 6.36022 21.75 7.25C21.75 8.13978 21.0784 8.86111 20.25 8.86111C19.4216 8.86111 18.75 8.13978 18.75 7.25C18.75 6.36022 19.4216 5.63889 20.25 5.63889Z",
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramicon);
export default __webpack_public_path__ + "static/media/instagramicon.1fc6d82758a16b63a5d1d0b4938b1ce9.svg";
export { ForwardRef as ReactComponent };